<div *ngIf="warning" class="warning-container">
  <div class="flex grid-gap-10">
    <div class="flex-shrink-1 warning-icon">
      <i class="fa fa-warning" style="color: #f97316"></i>
    </div>
    <div class="flex-grow-1">
      <div class="warning-title">Weekend or Bank Holiday</div>
      <div class="warning-text">
        The date range selected contains a Weekend or Bank Holiday. Ensure the site is open during
        this period before proceeding.
      </div>
    </div>
  </div>
</div>
